<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">Reports</div>
              <autocomplete
                class="q-ml-md"
                dense
                label="Competition"
                :items="competitions"
                :itemsLoading="competitionsLoading"
                option_label="competition_name"
                option_value="id"
                clearable
                @changed="
                  val => {
                    competition_id = val;
                  }
                "
              />
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div class="row">
              <div class="col-12 q-pa-sm">
                <q-btn
                  :disable="!competition_id"
                  label="Invoice Report"
                  icon="mdi-download"
                  color="secondary"
                  class="text-black"
                  @click="downloads('invoiceReport')"
                ></q-btn>
              </div>
              <div class="col-12 q-pa-sm">
                <q-btn
                  :disable="!competition_id"
                  label="Entries Report"
                  icon="mdi-download"
                  color="secondary"
                  class="text-black"
                  @click="downloads('CompetitionEntriesSummary')"
                ></q-btn>
              </div>
              <div class="col-12 q-pa-sm">
                <q-btn
                  :disable="!competition_id"
                  label="Support Members Report"
                  icon="mdi-download"
                  color="secondary"
                  class="text-black"
                  @click="downloads('SupportMembers')"
                ></q-btn>
              </div>
              <div class="col-12 col-sm-4 q-mb-sm">
                <q-select
                  :options="seasons"
                  v-model="season"
                  label="Season"
                  v-bind="siteCFG.fields.general"
                  clearable
                >
                </q-select>
              </div>
              <div class="col-12  col-sm-4 q-pa-sm">
                <q-btn
                  label="Season Stats Report"
                  icon="mdi-download"
                  color="secondary"
                  class="text-black"
                  :disable="!season"
                  @click="downloads('WavesCompetitionStatsReport')"
                ></q-btn>
              </div>
              <div class="col-12  col-sm-4 q-pa-sm">
                <q-btn
                  label="Coach/Manager Contacts"
                  icon="mdi-download"
                  color="secondary"
                  class="text-black"
                  :disable="!season"
                  @click="downloads('CoachManagerContacts')"
                ></q-btn>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";

import autocomplete from "@/components/wrappers/autocomplete/autocomplete.vue";
import api from "@/api.js";

// import { Notify } from "quasar";

export default {
  components: {
    autocomplete
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      siteCFG: "settings/siteCFG",
      competitions: "competitions/list",
      competitionsLoading: "competitions/listLoading",
      seasons: "settings/availableSeasons"
    })
  },
  data: () => ({
    competition_id: null,
    season: null
  }),
  watch: {},
  mounted() {
    // Load Competitions
    this.$store.dispatch("competitions/loadAll");
  },
  methods: {
    downloads(type) {
      switch (type) {
        case "invoiceReport":
          window.open(
            `${api.defaults.baseURL}/competition/invoiceBuilder/download?competitions_id=${this.competition_id}`,
            "_blank"
          );
          break;

        case "CompetitionEntriesSummary":
          window.open(
            `${api.defaults.baseURL}/report/download?competitions_id=${this.competition_id}&type=CompetitionEntriesSummary`,
            "_blank"
          );
          break;
        case "SupportMembers":
          window.open(
            `${api.defaults.baseURL}/report/download?competitions_id=${this.competition_id}&type=SupportMembers`,
            "_blank"
          );
          break;

        case "CompetitionEntriesTableMirror":
          window.open(
            `${api.defaults.baseURL}/report/download?competitions_id=${this.competition_id}&type=CompetitionEntriesTableMirror`,
            "_blank"
          );
          break;
        case "WavesCompetitionStatsReport":
          window.open(
            `${api.defaults.baseURL}/report/download?season=${this.season}&type=WavesCompetitionStatsReport`,
            "_blank"
          );
          break;
        case "CoachManagerContacts":
          window.open(
            `${api.defaults.baseURL}/report/download?season=${this.season}&type=CoachManagerContacts`,
            "_blank"
          );
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
